import { useEffect } from 'react';

const META_ID = 'mirage-noindex-meta';

const NoIndexMeta = () => {
  useEffect(() => {
    const existing = document.getElementById(META_ID);
    const meta = existing || document.createElement('meta');

    if (!existing) {
      meta.id = META_ID;
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }

    const previous = meta.getAttribute('content');
    meta.setAttribute('content', 'noindex, nofollow, noarchive, nosnippet, noimageindex');

    return () => {
      if (previous) {
        meta.setAttribute('content', previous);
      } else {
        meta.remove();
      }
    };
  }, []);

  return null;
};

export default NoIndexMeta;
